'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-length-of-stay-tooltip-template.html'));
var ChartLengthOfStayController = function ChartLengthOfStayController($scope, $filter, $rootScope, formatter, momentService, BrushSelectionFilter, dataProviderService) {
  var minimalSelectionSize = 45;
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.selectedOriginalService = null;
  $scope.redrawChart = function (originalService) {
    $scope.selectedOriginalService = originalService;
    reloadChart(originalService);
  };
  function reloadChart(service) {
    $scope.$evalAsync(function () {
      $scope.setLoadingMessage();
      if (!service) {
        $scope.data = [];
        $scope.renderChart($scope.data, 0);
        return;
      }
      dataProviderService.getData(service, $scope.$parent.snapshotDate).then(function (chartData) {
        var defaultSelectionSize = chartData.data.length;
        $scope.lengthOfStay = chartData.originalLengthOfStay;
        $scope.carryCount = chartData.originalCarryCount;
        if (defaultSelectionSize > minimalSelectionSize) {
          defaultSelectionSize = minimalSelectionSize;
        }
        $scope.data = chartData.data;
        $rootScope.$broadcast('chart:LengthOfStay:dataSize', _.filter($scope.data, {
          isGap: false
        }).length);
        setTimeout(function () {
          $scope.renderChart($scope.data, defaultSelectionSize);
        }, 0);
      });
    });
  }
  function createCompCarriers(compCarriersOutbound, compCarriersInbound) {
    var lowestCompFare = _.concat(compCarriersOutbound, compCarriersInbound);
    return '(' + _.uniq(lowestCompFare).join(',') + ')';
  }
  function dataFunction() {
    return $scope.data;
  }
  $scope.chartFormatters = {
    yAxisTickFormatter: formatter.humanReadable,
    xAxisTickFormatter: formatter.returnStackLabelFormatter(dataFunction),
    tooltipFormatter: function tooltipFormatter(d) {
      var servicesDetails = '';
      _.forEach(_.uniqBy(d.data, 'serviceId'), function (service) {
        var serviceIdWithoutDate = service.serviceId.split('[')[0];
        servicesDetails += _.capitalize(service.direction) + ': ' + serviceIdWithoutDate + '</br>';
      });
      var tooltipModel = {
        lengthOfStay: d.lengthOfStay + 'd',
        servicesDetails: servicesDetails,
        origFare: rmNumberFormat(d.m2, 'NUMBER'),
        recFare: rmNumberFormat(d.m1, 'NUMBER'),
        compCarriers: createCompCarriers(d.compCarriersOutbound, d.compCarriersInbound),
        lowestCompFare: rmNumberFormat(d.m3, 'NUMBER'),
        compCarriersTOD: d.isTOD ? createCompCarriers(d.compCarriersOutboundTOD, d.compCarriersInboundTOD) : null,
        lowestCompFareTOD: d.isTOD ? rmNumberFormat(d.m4, 'NUMBER') : null,
        isTOD: d.isTOD
      };
      return tooltipTemplate(tooltipModel);
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'date-range-chart-tooltip';
  $scope.viewportFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter() {
      return '';
    }
  };
  function calculatePercentage(d) {
    return d.m1 / d.m2 - 1;
  }
  function getFilterMethod(filter) {
    var filterMethod = {
      lte30pct: function lte30pct(d) {
        var percentage = calculatePercentage(d);
        return percentage >= 0 && percentage < 0.30;
      },
      lte60pct: function lte60pct(d) {
        var percentage = calculatePercentage(d);
        return percentage >= 0.30 && percentage < 0.60;
      },
      lte90pct: function lte90pct(d) {
        var percentage = calculatePercentage(d);
        return percentage >= 0.60 && percentage < 0.90;
      },
      gte90pct: function gte90pct(d) {
        var percentage = calculatePercentage(d);
        return percentage > 0.90;
      },
      lte1pct: function lte1pct(d) {
        var percentage = calculatePercentage(d);
        return percentage < 0;
      }
    };
    if (filterMethod[filter] === undefined) {
      return function () {
        return false;
      };
    }
    return filterMethod[filter];
  }
  $scope.filterDataByPCT = function (filter) {
    if (filter === 'ALL') {
      return undefined;
    }
    var selectedData = _.filter($scope.data, getFilterMethod(filter));
    return _.map(selectedData, 'lengthOfStay');
  };
  $scope.emitLengthOfStayServiceSelected = function (index, isOneBar) {
    $rootScope.$broadcast('chart:lengthOfStay:selected', $scope.data[index], $scope.selectedOriginalService, isOneBar, $scope.$parent.snapshotDate);
  };
  $scope.viewportReset = function () {
    $scope.resetViewportSelection($scope.data, $scope.data.length);
  };
};
ChartLengthOfStayController.$inject = ['$scope', '$filter', '$rootScope', 'FormatterService', 'MomentService', 'BrushSelectionFilterFactory', 'ChartLengthOfStayDataRetrieverService'];
module.exports = ChartLengthOfStayController;